export enum ProposalType {
  PURCHASE = 'purchase',
  REMOTE_DEVELOPMENT = 'remote_development',
  LOCAL_DEVELOPMENT = 'local_development',
}
